"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDesignObjectWhere = buildDesignObjectWhere;
const QueryBuilder_1 = require("../QueryBuilder");
function parseDesignObjectValue(value) {
    if (value === undefined || value === '') {
        throw new Error('Design-object filter requires a value.');
    }
    const parsed = JSON.parse(value);
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
        throw new Error('Design-object filter value must be a JSON object.');
    }
    const candidate = parsed;
    if (typeof candidate.type !== 'string') {
        throw new Error('Design-object filter value requires a string type.');
    }
    return {
        type: candidate.type,
        net: typeof candidate.net === 'string' ? candidate.net : null,
        module: typeof candidate.module === 'string' ? candidate.module : null,
        component: typeof candidate.component === 'string' ? candidate.component : null,
        signal: typeof candidate.signal === 'string' ? candidate.signal : null,
    };
}
function buildDesignObjectIdentityWhere(value) {
    const parsed = parseDesignObjectValue(value);
    return {
        type: parsed.type,
        net: parsed.net,
        module: parsed.module,
        component: parsed.component,
        signal: parsed.signal,
    };
}
function buildDesignObjectMatch(value) {
    return {
        logEntryLinks: {
            some: {
                logEntry: {
                    designObjectLinks: {
                        some: { buildDesignObject: buildDesignObjectIdentityWhere(value) },
                    },
                },
            },
        },
    };
}
function buildDesignObjectAnyMatch(value) {
    const values = (0, QueryBuilder_1.parseIsAnyOfValues)(value);
    return {
        logEntryLinks: {
            some: {
                logEntry: {
                    designObjectLinks: {
                        some: { buildDesignObject: { OR: values.map(buildDesignObjectIdentityWhere) } },
                    },
                },
            },
        },
    };
}
function buildDesignObjectNoMatch(value) {
    return {
        logEntryLinks: {
            none: {
                logEntry: {
                    designObjectLinks: {
                        some: { buildDesignObject: buildDesignObjectIdentityWhere(value) },
                    },
                },
            },
        },
    };
}
function buildDesignObjectNoneMatch(value) {
    const values = (0, QueryBuilder_1.parseIsAnyOfValues)(value);
    return {
        logEntryLinks: {
            none: {
                logEntry: {
                    designObjectLinks: {
                        some: { buildDesignObject: { OR: values.map(buildDesignObjectIdentityWhere) } },
                    },
                },
            },
        },
    };
}
function buildDesignObjectPresence(isPresent) {
    return {
        logEntryLinks: {
            [isPresent ? 'some' : 'none']: {
                logEntry: {
                    designObjectLinks: { some: {} },
                },
            },
        },
    };
}
function buildDesignObjectWhere(operator, value) {
    switch (operator) {
        case 'is':
        case 'equals':
            return buildDesignObjectMatch(value);
        case 'not':
        case 'doesNotEqual':
            return buildDesignObjectNoMatch(value);
        case 'isAnyOf':
            return buildDesignObjectAnyMatch(value);
        case 'isNoneOf':
            return buildDesignObjectNoneMatch(value);
        case 'isEmpty':
            return buildDesignObjectPresence(false);
        case 'isNotEmpty':
            return buildDesignObjectPresence(true);
        default:
            return {};
    }
}
//# sourceMappingURL=design-object-filter-where.js.map